import TestemunhoIndividual from './TestemunhoIndividual';

function RafaelFadel() {
    return <TestemunhoIndividual testimonialId={4} />;
}

export default RafaelFadel;